import React, { useState, useRef, useEffect } from "react";
import { useGeo } from "../../utils/GeoContext";

const FLAG_PK = "🇵🇰";
const FLAG_GLOBE = "🌐";

const RegionSwitcher = () => {
  const { region, switchRegion } = useGeo();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  // close on outside click
  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const options = [
    { value: "pk", label: "Pakistan", flag: FLAG_PK },
    { value: "standard", label: "Standard", flag: FLAG_GLOBE },
  ];

  const current = options.find((o) => o.value === region) || options[1];

  return (
    <div ref={ref} className="relative inline-block text-left">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-md text-xs font-medium text-white/90 hover:bg-white/10 transition-colors"
        title="Switch region"
      >
        <span className="text-sm">{current.flag}</span>
        <span className="hidden sm:inline">{current.label}</span>
        <svg
          className={`w-3 h-3 transition-transform ${open ? "rotate-180" : ""}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {open && (
        <div className="absolute right-0 mt-1 w-36 rounded-lg shadow-lg bg-white ring-1 ring-black/5 z-[60] overflow-hidden">
          {options.map((opt) => (
            <button
              key={opt.value}
              onClick={() => {
                switchRegion(opt.value);
                setOpen(false);
              }}
              className={`w-full flex items-center gap-2 px-3 py-2.5 text-sm transition-colors ${
                region === opt.value
                  ? "bg-gray-100 font-semibold text-gray-900"
                  : "text-gray-700 hover:bg-gray-50"
              }`}
            >
              <span>{opt.flag}</span>
              <span>{opt.label}</span>
              {region === opt.value && (
                <svg className="w-4 h-4 ml-auto text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default RegionSwitcher;
